import { createStore } from 'effector';

export const initialWorkspaceRole = 'visitor';

export const $workspaceRole = createStore(initialWorkspaceRole);

export const $isWorkspaceMember = $workspaceRole.map((role) => role === 'editor' || role === 'admin');
